import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Landing from "@/pages/Landing";
import Home from "@/pages/Home";
import Hire from "@/pages/Hire";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";

const isHireHost = /^hir(e|ing)\./.test(window.location.hostname);

function App() {
    return (
        <div className="App font-sans antialiased text-[#0A0A0A] bg-white">
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={isHireHost ? <Hire /> : <Home />} />
                    <Route path="/hiring" element={<Hire />} />
                    <Route path="/hire" element={<Navigate to="/hiring" replace />} />
                    <Route path="/creator-program" element={<Landing />} />
                    <Route path="/privacy" element={<Privacy />} />
                    <Route path="/terms" element={<Terms />} />
                    <Route path="*" element={<Navigate to="/" replace />} />
                </Routes>
            </BrowserRouter>
            <Toaster position="bottom-center" richColors />
        </div>
    );
}

export default App;
